var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextJap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.098,
    height: 30.739,
    viewBox: "0 0 32.098 30.739",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463",
    transform: "translate(-14.902 -302.261)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_420",
    "data-name": "Rectangle 420",
    width: 14,
    height: 3,
    rx: 1.5,
    transform: "translate(33 305)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_421",
    "data-name": "Rectangle 421",
    width: 14,
    height: 3,
    rx: 1.5,
    transform: "translate(33 313)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_422",
    "data-name": "Rectangle 422",
    width: 32,
    height: 3,
    rx: 1.5,
    transform: "translate(15 322)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_423",
    "data-name": "Rectangle 423",
    width: 32,
    height: 3,
    rx: 1.5,
    transform: "translate(15 330)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    "data-name": "Union 6",
    d: "M-3179.089-1370.172a1.42,1.42,0,0,1,1.369-1.407,3.7,3.7,0,0,0,2.6-1.854,10.909,10.909,0,0,0,1.243-3.539c-.639-.014-1.336-.039-2.138-.074a13.757,13.757,0,0,1-2.585,3.55,1.343,1.343,0,0,1-.958.411,1.5,1.5,0,0,1-1.342-.927,1.32,1.32,0,0,1,.314-1.476,11.12,11.12,0,0,0,3.176-6.421,1.368,1.368,0,0,1,1.4-1.093,1.335,1.335,0,0,1,.343.044,1.411,1.411,0,0,1,1,1.667,12.441,12.441,0,0,1-.29,1.476c1.114.038,2.219.056,3.3.056,1.005,0,2.012-.016,2.992-.049h.052a1.319,1.319,0,0,1,1.34,1.359,1.393,1.393,0,0,1-1.363,1.451c-.779.025-1.573.041-2.365.045a13.465,13.465,0,0,1-1.9,5.27,6.445,6.445,0,0,1-4.739,2.918c-.033,0-.065,0-.1,0A1.418,1.418,0,0,1-3179.089-1370.172Z",
    transform: "translate(3195.902 1685.261)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextJap);
export default __webpack_public_path__ + "static/media/text-jap.f37c0d7585d6b542192cdf17f99d8372.svg";
export { ForwardRef as ReactComponent };